import React from 'react'
import "./index.css"
export default function Footer() {
    return (
        <footer className="footer">
            <div className="content has-text-centered">
                <p className='has-text-white'>
                    <strong className='has-text-white'>Portfolio App</strong> by <a className="has-text-green" href="https://github.com/mandgenikhil">Nikhil Mandge</a>. The source code is licensed
                    <span></span><a className="ml-1 has-text-green" href="http://opensource.org/licenses/mit-license.php">MIT</a>
                </p>
            </div>
        </footer>
    )
}
